(function () {
  function initSection(section) {
    if (!section || section.dataset.npInitialized === 'true') return;
    section.dataset.npInitialized = 'true';

    const variantSelect = section.querySelector('[data-variant-select]');
    const variantInput = section.querySelector('[data-variant-id]');
    const priceEl = section.querySelector('[data-price-now]');
    const compareEl = section.querySelector('[data-price-compare]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const qtyInput = section.querySelector('[data-qty]');
    const qtyChoices = section.querySelectorAll('[data-qty-choice]');
    const buyLinks = section.querySelectorAll('[data-buy-now]');
    const cartLinks = section.querySelectorAll('[data-add-cart]');
    const availabilityEl = section.querySelector('[data-availability]');
function isAvailable() {
  if (variantSelect) {
    return variantSelect.options[variantSelect.selectedIndex]?.dataset.available === 'true';
  }

  return variantInput?.dataset.available === 'true' ||
    (variantInput?.dataset.available == null &&
      section.querySelector('[data-buy-now]')?.getAttribute('aria-disabled') === 'false');
}
    function quantity() {
      return Math.max(1, parseInt(qtyInput?.value || '1', 10) || 1);
    }

    function variantId() {
      return variantInput?.value || '';
    }

    function updateQtyChoices() {
      const q = String(quantity());
      qtyChoices.forEach(choice => {
        choice.classList.toggle('is-active', choice.dataset.qtyChoice === q);
      });
    }

    function buildCartUrl(checkout) {
      const id = variantId();
      if (!id) return '#';
      const base = `${window.Shopify?.routes?.root || '/'}cart/${encodeURIComponent(id)}:${quantity()}`;
      return checkout ? `${base}?checkout` : base;
    }

    function setLinkState(available) {
      const checkoutUrl = buildCartUrl(true);
      const cartUrl = buildCartUrl(false);

      buyLinks.forEach(link => {
        link.href = available ? checkoutUrl : '#';
        link.setAttribute('aria-disabled', available ? 'false' : 'true');
      });

      cartLinks.forEach(link => {
        link.href = available ? cartUrl : '#';
        link.setAttribute('aria-disabled', available ? 'false' : 'true');
      });

      updateQtyChoices();
    }

    function syncVariant(option) {
      if (!option || !variantInput) return;
      variantInput.value = option.value;

      const price = option.dataset.price || '';
      const compare = option.dataset.compare || '';
      const available = option.dataset.available === 'true';

      if (priceEl) priceEl.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;

      section.querySelectorAll('[data-price-plan]').forEach(note => { note.dataset.variantMatches = String(price === note.dataset.expectedPrice); note.hidden = note.dataset.variantMatches === 'false' || Date.now() >= Date.parse(note.dataset.end); });
      section.querySelectorAll('nenilo-promotion').forEach(banner => { banner.dataset.variantMatches = String(price === banner.dataset.expectedPrice); });
      if (compareEl) {
        compareEl.textContent = compare;
        compareEl.hidden = !compare;
      }

     
      if (availabilityEl) {
  const language = (
    window.Shopify?.locale ||
    document.documentElement.lang ||
    'es'
  ).toLowerCase();

  const isEnglish = language.startsWith('en');

  availabilityEl.textContent = available
    ? (isEnglish ? '✓ Available to order' : '✓ Disponible para comprar')
    : (isEnglish ? 'Temporarily unavailable' : 'Agotado temporalmente');
}

      setLinkState(available);
    }

    if (variantSelect) {
      syncVariant(variantSelect.options[variantSelect.selectedIndex]);
      variantSelect.addEventListener('change', () => {
        syncVariant(variantSelect.options[variantSelect.selectedIndex]);
      });
    } else {
      setLinkState(isAvailable());
    }

    qtyInput?.addEventListener('input', () => {
      const available = isAvailable();
      setLinkState(available);
    });

    qtyChoices.forEach(choice => {
      choice.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = choice.dataset.qtyChoice || '1';
        const available = isAvailable();
        setLinkState(available);
      });
    });

    section.querySelectorAll('[data-buy-now], [data-add-cart]').forEach(link => {
      link.addEventListener('click', (event) => {
        if (link.getAttribute('aria-disabled') === 'true' || link.getAttribute('href') === '#') {
          event.preventDefault();
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-nlp-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();

if (!customElements.get('nenilo-promotion')) {
  customElements.define('nenilo-promotion', class extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.end || '';
      if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(raw)) return;
      this.deadline = Date.parse(raw);
      if (!Number.isFinite(this.deadline)) return;
      const time = this.querySelector('time');
      time.dateTime = raw;
      time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {dateStyle:'medium',timeStyle:'short'}).format(this.deadline);
      this.tick = () => {
        const remaining = Math.ceil((this.deadline - Date.now()) / 1000);
        this.hidden = remaining <= 0 || this.dataset.variantMatches === 'false';
        if (remaining <= 0) { clearInterval(this.timer); return; }
        if (this.hidden) return;
        const h = Math.floor(remaining / 3600);
        const m = Math.floor(remaining % 3600 / 60);
        const s = remaining % 60;
        this.querySelector('.nl-promo-clock').textContent = [h,m,s].map(n => String(n).padStart(2,'0')).join(':');
      };
      this.tick();
      if (!this.hidden) this.timer = setInterval(this.tick,1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
(function(){
  const observers = new Map();
  const sync = () => {
    observers.forEach((observer,bar) => { if (!bar.isConnected) {observer.disconnect();observers.delete(bar);} });
    document.querySelectorAll('.sticky-buy').forEach(bar => {
      if (!observers.has(bar)) {const observer = new ResizeObserver(measure);observer.observe(bar);observers.set(bar,observer);}
    });
    measure();
  };
  function measure(){
    let height = 0;
    document.querySelectorAll('.sticky-buy').forEach(bar => {height = Math.max(height,bar.getBoundingClientRect().height+32);});
    document.documentElement.style.setProperty('--nl-sticky-space',height+'px');
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',sync); else sync();
  document.addEventListener('shopify:section:load',sync);
  document.addEventListener('shopify:section:unload',()=>setTimeout(sync,0));
})();

(function () {
  function expireNotes() {
    document.querySelectorAll('[data-price-plan]').forEach(note => {
      const end = Date.parse(note.dataset.end);
      note.hidden = !Number.isFinite(end) || Date.now() >= end || note.dataset.variantMatches === 'false';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', expireNotes); else expireNotes();
  document.addEventListener('shopify:section:load', expireNotes);
  setInterval(expireNotes, 1000);
})();
